import React from 'react';
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import "./assets/scss/main.scss";
// Redux
// import { Provider } from 'react-redux';
// import { PersistGate } from "redux-persist/es/integration/react";
// import { persistor, store } from "./redux/store";

ReactDOM.render(
    // <Provider store={store}>
    //     <PersistGate loading={null} persistor={persistor}>
    <BrowserRouter>
        <Toaster
            position="top-center"
            containerStyle={{ zIndex: 99999 }}
            toastOptions={{
                style: {
                    background: '#ffffff',
                    color: '#000000',
                    // fontSize: '15px',
                    // padding: '14px 10px',
                    minWidth: '250px',
                    boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                },
                loading: {
                    iconTheme: {
                        primary: '#72b626',
                        secondary: '#e8e8e8'
                    },
                },
            }}
        />
        <App />
    </BrowserRouter>,
    //     </PersistGate>
    // </Provider>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
